<template>
    <div>
        <v-card elevation="0">
            <v-card-title>
                <v-icon>mdi-upload</v-icon>&nbsp;Upload File
            </v-card-title>
            <v-card-subtitle>

            </v-card-subtitle>
            <v-card-text>
                <v-row>
                    <v-col md="10">
                        <v-text-field
                            v-model="termValue"
                            label="Stream Code"
                            hint="Please enter the 4-digit stream code (e.g. 1229)"
                            persistent-hint
                            outlined
                            clearable
                            prepend-icon="mdi-key"
                            :rules="[v=> /^1\d{3}$/.test(v) || 'Stream Code is a 4-digit number that starts with 1.']"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col md="10">
                        <v-file-input
                            accept=".csv"
                            label="Choose ONE CSV file"
                            outlined
                            counter
                            id="uploadFile"
                            v-model="userFile"
                            @change="validateForm"
                            hint="File Upload for T2202A"
                            persistent-hint
                        ></v-file-input>
                    </v-col>
                </v-row>
                <v-row justify="end">
                    <v-col md="3">
                        <v-dialog
                            v-model="dialog"
                            persistent
                            width="400"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    :disabled="submitDisabled"
                                    color="#98B38F"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <span style="color: white;">Upload</span>
                                </v-btn>
                            </template>
                            <v-card>
                                <v-form target="hiddenFrame" @submit="submitForm">
                                    <v-toolbar elevation="1" dark color="#98B38F">
                                        <v-toolbar-title>Upload File?</v-toolbar-title>
                                    </v-toolbar><br />
                                    <v-card-subtitle>You are uploading:</v-card-subtitle>
                                    <v-card-text>
                                        Stream Code: <b>{{ termValue }}</b> <br /> <br />
                                        File: <b>{{ filename }}</b> <br />
                                    </v-card-text>
                                    <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        color="#E53935"
                                        text
                                        @click="dialog = false"
                                    >
                                        Cancel
                                    </v-btn>
                                    <v-btn
                                        color="green darken-1"
                                        text
                                        type="submit"
                                        :loading="uploadloading"
                                    >
                                        OK
                                    </v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
export default {
    data(){
        return {
            host: location.hostname.toString(),
            termValue: "",
            userFile: null,
            filename: "",
            submitDisabled: true,
            snackbar: false,
            snackbarcolor: "",
            text: "",
            timeout: 3500,
            dialog: false,
            uploadloading: false
        }
    },
    methods: {
        validateForm(){
            const that = this;
            //Upload Button control
            if(that.termValue.length < 4 || that.userFile == null){ //Checks if any two inputs are empty or not
                that.submitDisabled = true;
            }else {
                that.submitDisabled = false;
            }

            if(that.userFile != null){
                that.filename = document.getElementById("uploadFile").files[0].name;
                if(that.filename.split(".").slice(-1)[0].match(/^csv/i)){ //Checks if the uploaded file extension is .csv
                    that.submitDisabled = false;
                }else{
                    that.submitDisabled = true;
                }
            }
        },
        submitForm(){
            const that = this;
            that.uploadloading = true;
            let api= 'https://'+that.host+'/cgi-bin/sfs-portal-api/api.py';

            const formData = new FormData();
            formData.append("mode", "admint2202aupload");
            formData.append("file", that.userFile);
            formData.append("data", JSON.stringify({
                uploadtype : "T2202A Report",
                streamcode : that.termValue
            }));

            fetch(api, {
                method: 'POST',
                body: formData
            })
            .then(function(response){
                return response.json();
            })
            .then(function (data) {
                if(data.result.match(/ok/i)){
                    that.setSnackbar("Successful: "+data.message.toString(), "green");
                }else {
                    that.setSnackbar("Warning: "+data.message.toString(), "orange");
                }

                that.uploadloading = false;
                that.dialog = false;
            })
            .catch(function (err) {
                that.setSnackbar("Error occurred : "+err.toString(), "red");
                that.uploadloading = false;
                that.dialog = false;
            })

            that.userFile = null;
            //that.termValue = "";
            that.submitDisabled = true;
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        }
    }
}
</script>